<div class="common__app"
  id="centinela-app-template">
  @if (loadAllSources) {
    <div
      class="common__view"
      id="centinela-view-body"
      #centinelaviewbody>
      <p-toast position="bottom-right" key="br" [life]="3000" styleClass="common-status-message__toast-container">
        <ng-template let-message #headless let-closeFn="closeFn">
           <div class="common-status-message__g-container-info">
              <i aria-hidden="true" class="lf-icon-info-full common-status-message__icon-md"></i>
              <div class="common-status-message__g-content">
                  <div class="common-status-message__g-icon-text-content">
                    <div class="common-status-message__g-title-subtitle">
                      <span class="common-status-message__g-title">{{message.summary}}</span>
                      <span class="common-status-message__g-subtitle">{{message.detail}}</span>
                    </div>
                    <button type="button" class="common-button__icon-xs-noborder"
                      (click)="closeFn($event)">
                      <i aria-hidden="true" class="lf-icon-close-thick common-icon__sm"></i>
                    </button>
                  </div>
              </div>
            </div>
        </ng-template>
      </p-toast>
      <router-outlet></router-outlet>
    </div>
  }
</div>
@if (showSpinnerLoading) {
  <spinner-window
    [text]="anotherPageText"></spinner-window>
}
